module.exports = __webpack_public_path__ + "img/payser.c79ae72.svg";